import type { ReactNode } from "react";
import { BadgeRow } from "./BadgeRow";
import type { BadgeId } from "../lib/badges";

/** Shared identity line for self, member, and expanded profile cards. */
export function ProfileUsername({ username, badges = [], children }: {
  username: string;
  badges?: ReadonlyArray<BadgeId>;
  children?: ReactNode;
}) {
  return (
    <div className="mt-0.5 flex flex-wrap items-center gap-x-2 gap-y-1.5 text-sm text-cloud-500">
      <span className="min-w-0 max-w-full [overflow-wrap:anywhere]">@{username}</span>
      <BadgeRow
        badges={badges}
        size="sm"
        max={badges.length}
        className="max-w-full flex-wrap gap-1 rounded-md border border-cloud-300/60 bg-cloud-100/40 px-1.5 py-0.5 shadow-[inset_0_1px_0_rgba(255,255,255,0.12)] backdrop-blur-md"
      />
      {children}
    </div>
  );
}
